import _toConsumableArray from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { FilterBasedAccessor } from "./FilterBasedAccessor";
import { ObjectState } from "../state";

var identity = require("lodash/identity");

var maxBy = require("lodash/maxBy");

var get = require("lodash/get");

var assign = require("lodash/assign");

import { FilterBucket, HistogramBucket, RangeQuery, BoolMust, CardinalityMetric, FieldContextFactory } from "../query";
export var RangeAccessor =
/*#__PURE__*/
function (_FilterBasedAccessor) {
  _inherits(RangeAccessor, _FilterBasedAccessor);

  function RangeAccessor(key, options) {
    var _this;

    _classCallCheck(this, RangeAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeAccessor).call(this, key, options.id));
    _this.state = new ObjectState({});
    _this.translations = RangeAccessor.translations;
    _this.options = options;
    _this.options.fieldOptions = _this.options.fieldOptions || {
      type: "embedded"
    };
    _this.options.fieldOptions.field = _this.options.field;
    _this.fieldContext = FieldContextFactory(_this.options.fieldOptions);
    _this.options.rangeFormatter = _this.options.rangeFormatter || identity;

    if (options.translations) {
      _this.translations = assign({}, _this.translations, options.translations);
    }

    return _this;
  }

  _createClass(RangeAccessor, [{
    key: "getSelectedValue",
    value: function getSelectedValue(value) {
      var divider = this.translate("range.divider");
      return [this.options.rangeFormatter(value.min), divider, this.options.rangeFormatter(value.max)].join("");
    }
  }, {
    key: "buildSharedQuery",
    value: function buildSharedQuery(query) {
      var _this2 = this;

      if (this.state.hasValue()) {
        var val = this.state.getValue();
        var rangeFilter = this.fieldContext.wrapFilter(RangeQuery(this.options.field, {
          gte: val.min,
          lte: val.max
        }));
        var selectedFilter = {
          name: this.translate(this.options.title),
          value: this.getSelectedValue(val),
          id: this.options.id,
          remove: function remove() {
            _this2.state = _this2.state.clear();
          }
        };
        return query.addFilter(this.uuid, rangeFilter).addSelectedFilter(selectedFilter);
      }

      return query;
    }
  }, {
    key: "getBuckets",
    value: function getBuckets() {
      return this.getAggregations([this.uuid, this.fieldContext.getAggregationPath(), this.key, "buckets"], []);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      if (this.options.loadHistogram) {
        var maxValue = get(maxBy(this.getBuckets(), "doc_count"), "doc_count", 0);
        return maxValue === 0;
      } else {
        return this.getAggregations([this.uuid, this.fieldContext.getAggregationPath(), this.key, "value"], 0) === 0;
      }
    }
  }, {
    key: "getInterval",
    value: function getInterval() {
      if (this.options.interval) {
        return this.options.interval;
      }

      return Math.ceil((this.options.max - this.options.min) / 20);
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      var otherFilters = query.getFiltersWithoutKeys(this.uuid);
      var filters = BoolMust([otherFilters, this.fieldContext.wrapFilter(RangeQuery(this.options.field, {
        gte: this.options.min,
        lte: this.options.max
      }))]);
      var metric;

      if (this.options.loadHistogram) {
        metric = HistogramBucket(this.key, this.options.field, {
          "interval": this.getInterval(),
          "min_doc_count": 0,
          "extended_bounds": {
            "min": this.options.min,
            "max": this.options.max
          }
        });
      } else {
        metric = CardinalityMetric(this.key, this.options.field);
      }

      return query.setAggs(FilterBucket.apply(void 0, [this.uuid, filters].concat(_toConsumableArray(this.fieldContext.wrapAggregations(metric)))));
    }
  }]);

  return RangeAccessor;
}(FilterBasedAccessor);
RangeAccessor.translations = {
  "range.divider": " - "
};